import { render, staticRenderFns } from "./detailAndApprove.vue?vue&type=template&id=38a964c4&scoped=true&"
import script from "./detailAndApprove.vue?vue&type=script&lang=js&"
export * from "./detailAndApprove.vue?vue&type=script&lang=js&"
import style0 from "./detailAndApprove.vue?vue&type=style&index=0&id=38a964c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a964c4",
  null
  
)

export default component.exports